// TagsContext.js
import React, { createContext, useState, useEffect } from 'react';
import { tagsPathTo } from '../utils/Api';

const TagsContext = createContext();

const TagsProvider = ({ children }) => {
  const [tags, setTags] = useState([]);
  
  useEffect(() => {
    fetchTags();
  }, []);
  
  const fetchTags = async () => {
    try {
      const response = await tagsPathTo.list();
      setTags(response.data);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  const addTag = (tag) => {
    setTags([...tags, tag]);
  };

  const updateTag = (tag) => {
    setTags(tags.map((t) => (t.id === tag.id ? tag : t)));
  };

  const removeTag = (id) => {
    setTags(tags.filter((t) => t.id !== id));
  };

  return (
    <TagsContext.Provider value={{ tags, setTags, updateTag, addTag, removeTag }}>
      {children}
    </TagsContext.Provider>
  );
};

export { TagsContext, TagsProvider };